export default "__VITE_ASSET__f828558f__"